export default __webpack_public_path__ + "static/media/icons-arrow-down.dbfe54fd.svg";